export default "__VITE_ASSET__CM5gK69$__"